/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_9aca09eb{display:block}.resizeIsShort_9aca09eb{width:400px}.buttonGroup_9aca09eb{margin-bottom:40px}.buttonGroup_9aca09eb button{margin-right:20px}.settingsGroup_9aca09eb{padding-top:20px}.itemCountDropdown_9aca09eb{width:180px}\n"}]);
export const root = "root_9aca09eb";
export const resizeIsShort = "resizeIsShort_9aca09eb";
export const buttonGroup = "buttonGroup_9aca09eb";
export const settingsGroup = "settingsGroup_9aca09eb";
export const itemCountDropdown = "itemCountDropdown_9aca09eb";